export const USER_PAYMENT_METHOD_STRINGS = {
  title: "Let's get you paid!",
  subtitle:
    'Belong will send you rent for this home, less any fees, via the payment method <span>of your choice.</span>',
};
